import styled, { css } from 'styled-components'
import { lighten } from 'polished'

export const CartContainer = styled.div`
  width: 100%;
`

export const CartSticky = styled.div`
  ${({ isCartOnProductsList }) => isCartOnProductsList && css`
    overflow-y: auto;
    max-height: 70vh;
    position: sticky;
    top: 20px;
  `}
  width: 100%;
`

export const OrderBill = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 10px 0px;
  background-color: ${isCheckout => isCheckout ? 'transparent' : '#FFF'};
  table {
    width: 100%;
    font-size: 14px;

    td span {
      unicode-bidi: bidi-override;
    }

    tr td:nth-child(2) {
      text-align: right;
      ${props => props.theme?.rtl && css`
        text-align: left;
    `}
    }

    .icon {
      display: flex;
      align-items: center;
      max-height: 25px;
    }
  }
  table.total {
    border-top: 1px solid #EAEAEA;
    padding-top: 10px;
    tr {
      td {
        font-weight: bold;
        color: ${props => props.theme.colors.darkTextColor};
        font-size: 16px;

        &#loyalty {
          font-weight: normal;
          font-size: 14px;
        }
      }
    }
  }
  table.comments {
    margin-top: 20px;
    tr {
      td:nth-child(1) {
        font-weight: bold;
      }
    }
    textarea {
      width: 100%;
      box-sizing: border-box;
      border-radius: 7.6px;
      height: 77px;
      padding-right: 60px;
    }
  }
  table.spot {
    tr {
      td:nth-child(1) {
        font-weight: bold;
      }
      td:nth-child(2) {
        font-weight: bold;
        color: ${({ theme }) => theme.colors.primary};
        cursor: pointer;
        &:hover {
        text-decoration: underline;
      }
      }
    }
  }
`

export const CouponContainer = styled.div`
  width: 100%;
  margin: 10px;

  input, button {
    border-radius: 7.6px;
  }
`

export const CheckoutAction = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  p {
    margin: 0;
    font-weight: 600;
    font-size: 18px;
    color: ${props => props.theme.colors.darkTextColor};
  }

  button {
    padding: 10px 30px;
    min-width: 150px;
    width: 50%;
    &:disabled{
      opacity: 0.5;
      cursor: not-allowed
    }
  }
`

export const Divider = styled.div`
  background: #F8F9FA;
  height: 8px;
  width: 100%;
  margin-left: 0;

  @media (min-width: 768px) {
    width: calc(100% + 60px);
    margin-left: -30px;
  }
`

export const Exclamation = styled.div`
  position: relative;
  display: inline-flex;
  cursor: pointer;
  margin-left: 5px;
  top: 3px;
`

export const Spinner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-20%, 15%);
`

export const CommentContainer = styled.td`
  position: relative;
  .spinner-content > div{
    width: 50px;
    height: 50px;
  }
`

export const IconContainer = styled.div`
  position: relative;
  display: inline-flex;
  cursor: pointer;
  margin-left: 5px;
  height: 20px;
  svg:nth-child(1){
    position: relative;
    top: -1px;
  }
  svg:nth-child(2){
    position: relative;
    top: -3px;
  }
`

export const SavedContainer = styled.span`
  margin-top: 10px;
  font-size: 20px;
  font-weight: bold;
  color: ${props => props.theme?.colors?.primaryContrast};
  background: ${props => lighten('0.2', props.theme?.colors?.primary)};
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const SpotSelect = styled.select`
  ${({ isCheckout }) => isCheckout
    ? css`
    background: ${props => props.theme?.colors.backgroundPage};
  `
    : css`
    background: ${props => props.theme?.colors.grayDividerColor};
  `}
  border-radius: 7.6px;
  height: 25px;
  border: none;
  font-size: 12px;
  outline: none;
  margin: 0 5px 0 15px;
  padding: 0 3px;
  cursor: pointer;
  -moz-appearance: none;
  -webkit-appearance: none;
  -ms-progress-appearance: none;

  ${props => props.theme.rtl && css`
    margin: 0 15px 0 5px;
  `}
`
export const NoValidProductMessage = styled.p`
  font-size: 14px;
`
export const DriverTipContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 20px 0px 0px;
  h1 {
    margin: 0px;
    font-weight: 500;
    font-size: 20px;
    color: ${props => props.theme.colors.darkTextColor};
  }
  > p {
    margin: 0;
    font-size: 16px;
    color: ${props => props.theme?.colors.darkGray};
  }
`

export const SpinnerCart = styled.div`
  position: absolute;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ emptyCart }) => emptyCart && css`
    top: 0;
  `}
`

export const WarningText = styled.p`
  margin: 10px auto;
  text-align: center;
  color: ${props => props.theme.colors.primary};
`

export const ReservationAlert = styled.div`
  p{
    color: ${props => props.theme?.colors?.danger500};
  }
`
export const BannerContainer = styled.div`
  width: 100%;
  margin: 0 0 20px;
  overflow: hidden;
  height:390px;
  // padding:40px 10px 30px 10px;
  background-color: #A1BF9E;
  .swiper-button-next {
    background-image: url(${props => props.theme.images.general.rightArrow});
    background-color: #d1d0d04d;
    background-repeat: no-repeat;
    background-position: 55% center;
    width: 32px;
    height: 32px;
    box-shadow: rgb(0 0 0 / 7%) 0px 4px 10px;
    border-radius: 50%;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  .swiper-button-prev {
    // background-image: url(${props => props.theme.images.general.leftArrow});
    background-color: #325D51;
    background-position: 45% center;
    width: 20px;
    height: 50px;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.05);
    }
  }
    .swiper-button-next {
    background-image: none !important;
    background-color: #325D51 !important;
    background-position: 45% center;
    width: 20px !important;
    height: 50px !important;
    transition: all 0.2s ease;
    border-radius:0px !important;

    &:hover {
      transform: scale(1.05);
    }
  }

  .swiper-button-prev, .swiper-button-next{
  color : #ffffff
  }

  .swiper-button-prev:after, .swiper-button-next:after{
  font-size : 15px
  }

  @media (max-width: 992px) {
    height:auto;
  }

`
export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  img.banner-img {
    width: 100%;
    height: auto;
  }

  .text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    text-align: center;
    background: rgba(0, 0, 0, 0.5); /* Optional background for contrast */
    padding: 20px;
    border-radius: 10px;
  }

  .text-overlay h2 {
    font-size: 24px;
    margin-bottom: 10px;
  }

  .text-overlay p {
    font-size: 16px;
  }
`
export const SlideWrapper = styled.div`
display: flex;
  flex-direction: row; /* Horizontal layout */
  width:'100%';
  justify-content: space-between;
  height: 150px;

  background-color: #f9f9f9;
  border: 1px solid #ddd; /* Optional border */
  border-radius: 10px; /* Optional rounded corners */
  text-align: left; /* Align text to the left */

  img {
    width: '40%'; /* Adjust image width as needed */
    height: '100%'; /* Keep the image proportionate */
    object-fit: 'cover';
    flex:1

  }

  .lkzvRK .swiper-button-prev{
   background-color: #325D51 !important;
   width: 27px !important;
  }
`

export const ImageSection = styled.div`

`

export const BannerHeaderSection = styled.div`
  width: 90%;
  background-color: #325D51;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px 15px 16px;
  flex-wrap: wrap;
  gap: 30px;

  p {
    margin: 0;
    font-weight: 600;
    color: #fff;
    font-size: 50px;
    font-family: Poppins;
  }

  span {
    border-left: 3px solid #fff;
    padding: 15px;
    font-weight: 600;
    color: #fff;
    font-size: 30px;
  }
  @media (max-width: 767px) {
    p {
    font-size: 26px;
  }

    span {
      font-size: 16px;
    }
  }
}
`

export const TextSection = styled.div`
  flex: 2; /* Text takes 2/3 of the space */
  padding: 10px; /* Add space between image and text */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;

  h2 {
    font-size: 13px;
    color: #333;
    padding: 0;
    margin: 0;
  }

  p {
    font-size: 12px;
    color: #666;
    padding: 0;
    margin: 0;
    font-weight: 100;
    height: 60px;
    overflow-y: auto;
  }

  button {
    margin-top: 10px;
    padding: 8px 12px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 12px;

    &:hover {
      background-color: #0056b3;
    }
  }
`
